import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { MaintenanceDate } from "../../model/maintenance-schedule.model";

export const maintenanceScheduleActions = createActionGroup({
    source: 'Maintenance Schedule',
    events: {
        updateCheckMaintenanceSchedule: emptyProps(),
        //the action to check if there is an active window.
        setCheckMaintenanceSchedule: props<{ maintenanceDate: MaintenanceDate | null, successful: boolean }>(),
        //the action to call the api and set a new maintenance window for the admin
        updateMaintenanceSchedule: props<{ maintenanceDate: MaintenanceDate }>(),
        updateStopMaintenanceSchedule: emptyProps(),
    }
});